export const FETCH_INCIDENT_CONFIGURATION_BY_GROUP_ID =
  'FETCH_INCIDENT_CONFIGURATION_BY_GROUP_ID';
export const PUT_INCIDENT_CONFIGURATION = 'PUT_INCIDENT_CONFIGURATION';
